import assets from "../../assets";
import "./style.sass";
import { useHandler } from "./handler";
import { DescriptiveHero } from "../descriptive-hero";
import { QuestionSection } from "../question-section";
import {
  QUESTION_WEIGHTAGE_CBSE,
  QUESTION_WEIGHTAGE_STATE_BOARD,
  LANGUAGE_OPTIONS,
} from "../../utils/constant";

export const Descriptive = () => {
  const {
    user,
    mail,
    openDropdown,
    selectedSubject,
    chapters,
    subjects,
    isStartEnabled,
    isLoading,
    selectChapters,
    mediums,
    selectedMedium,
    section,
    setSelectedChapters,
    setOpenDropdown,
    setSelectedSubject,
    onStartQuiz,
    setIsQuizActive,
    isQuizActive,
    selectedLanguage,
    setSelectedLanguage,
    selectedWeightage,
    setSelectedWeightage,
    selectedQuestionCount,
    setSelectedQuestionCount,
    getQuestionCountOptions,
    setSelectedMedium,
    dropdownWrapperRef,
    questions,
  } = useHandler();

  const handleResetAll = () => {
    setSelectedSubject("");
    setSelectedChapters([]);
    setSelectedLanguage("");
    setSelectedWeightage("");
    setSelectedQuestionCount("");
    setIsQuizActive(false);
  };

  return (
    <section className="desc_layout">
      <section className="desc_nav_context_contanier">
        <section className="desc_nav_learn_title">
          <h4>Descriptive Test</h4>
          <h6>Configure test details and generate questions</h6>
        </section>

        <section className="desc_nav_subject_details">
          <section className="desc_board_wrapper">
            <section className="desc_board">
              <h5>Board</h5>
              <h4>{user?.data?.board}</h4>
            </section>
            <section className="desc_class">
              <h5>Class</h5>
              <h4>{user?.data?.class}</h4>
            </section>
          </section>
        </section>

        <section className="quiz_default_medium_wrapper">
          <h4>Medium</h4>
          <h5>{user?.data?.medium}</h5>
        </section>

        <section className="desc_nav_subject_wrapper" ref={dropdownWrapperRef}>
          {/* MEDIUM */}
          {/* <section
            className="desc_subject_wrapper"
            onClick={() => setOpenDropdown("medium")}
          >
            <h4>Medium</h4>
            <section className="desc_drop_down_wrapper">
              <p>{selectedMedium || "Select Subject"}</p>
              <img src={assets.ic_chevron_down} alt="ic_chevron_down" />
            </section>
            {openDropdown === "medium" && (
              <section className="desc_options_list">
                {isLoading ? (
                  <p className="dropdown-message">Loading mediums...</p>
                ) : mediums?.length > 0 ? (
                  mediums?.map((item, i) => (
                    <p
                      key={i}
                      className="desc_option_item"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedMedium(item);
                        setOpenDropdown(null);
                      }}
                    >
                      {item}
                    </p>
                  ))
                ) : (
                  <p className="dropdown-message red">No subjects found</p>
                )}
              </section>
            )}
          </section> */}

          {/* SUBJECT */}
          <section
            className="desc_subject_wrapper"
            onClick={() => setOpenDropdown("subject")}
          >
            <h4>Subject</h4>
            <section className="desc_drop_down_wrapper">
              <p>{selectedSubject || "Select Subject"}</p>
              <img src={assets.ic_chevron_down} alt="ic_chevron_down" />
            </section>
            {openDropdown === "subject" && (
              <section className="desc_options_list">
                {
                  // !selectedMedium ? (
                  //   <p className="dropdown-message">Please first Choose Medium</p>
                  // ):
                  isLoading ? (
                    <p className="dropdown-message">Loading subjects...</p>
                  ) : subjects?.length > 0 ? (
                    subjects?.map((item, i) => (
                      <p
                        key={i}
                        className="desc_option_item"
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedSubject(item);
                          setOpenDropdown(null);
                        }}
                      >
                        {item}
                      </p>
                    ))
                  ) : (
                    <p className="dropdown-message red">No subjects found</p>
                  )
                }
              </section>
            )}
          </section>

          {/* CHAPTER */}
          <section
            className="desc_subject_wrapper"
            // ref={chapterRef}
            onClick={() => setOpenDropdown("chapter")}
          >
            <h4>Chapter</h4>
            <section className="desc_drop_down_wrapper">
              {/* <p>  {selectChapters.length > 0  ? selectChapters.join(", ") : "Select Chapter"}</p> */}
              <section className="desc_selected_chapter_list">
                {selectChapters?.length === 0 ? (
                  <p>Select Chapter</p>
                ) : (
                  selectChapters?.map((item, index) => {
                    return (
                      <section key={index} className="desc_items">
                        <p>{item}</p>
                        <img
                          src={assets.ic_close_white}
                          alt="ic_close_white"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedChapters((prev) =>
                              prev.filter((c) => c !== item),
                            );
                          }}
                          style={{
                            cursor: "pointer",
                            width: "14px",
                            height: "14px",
                          }}
                        />
                      </section>
                    );
                  })
                )}
              </section>
              <img src={assets.ic_chevron_down} alt="" />
            </section>
            {openDropdown === "chapter" && (
              <section className="desc_options_list">
                {!selectedSubject ? (
                  <p className="dropdown-message">
                    Please first Choose Subject
                  </p>
                ) : isLoading ? (
                  <p className="dropdown-message">Loading chapters...</p>
                ) : chapters?.length > 0 ? (
                  chapters?.map((item, i) => (
                    <p
                      key={i}
                      className={`desc_option_item ${selectChapters.includes(item) ? "selected" : ""}`}
                      onClick={(e) => {
                        setSelectedChapters((prev) => {
                          // If clicked item is "All Chapters"
                          if (item === "All Chapters") {
                            // If already selected â†’ remove it
                            if (prev.includes("All Chapters")) {
                              return [];
                            }
                            // Else â†’ only select "All Chapters"
                            return ["All Chapters"];
                          }

                          // If selecting individual chapter â†’ remove "All Chapters"
                          let updated = prev.filter(
                            (c) => c !== "All Chapters",
                          );

                          if (updated.includes(item)) {
                            // remove if already selected
                            updated = updated.filter((c) => c !== item);
                          } else {
                            // add new chapter
                            updated = [...updated, item];
                          }

                          return updated;
                        });
                      }}
                    >
                      {item}
                      {selectChapters.includes(item) && " ✓"}
                    </p>
                  ))
                ) : (
                  <p className="dropdown-message red">No chapters found</p>
                )}
              </section>
            )}
          </section>
          <section
            className="desc_subject_wrapper"
            // ref={languageRef}
            onClick={() => setOpenDropdown("weightage")}
          >
            <h4>Question Weightage</h4>
            <section className="desc_drop_down_wrapper">
              <p>{selectedWeightage || "Select Weightage"}</p>
              <img src={assets.ic_chevron_down} alt="" />
            </section>
            {openDropdown === "weightage" && (
              <section className="desc_options_list">
                {(user?.data?.board === "CBSE"
                  ? QUESTION_WEIGHTAGE_CBSE
                  : QUESTION_WEIGHTAGE_STATE_BOARD
                )?.map((item, i) => (
                  <p
                    key={i}
                    className="desc_option_item"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedWeightage(item);
                      setSelectedQuestionCount(""); // reset count when weightage changes
                      setOpenDropdown(null);
                    }}
                  >
                    {item}
                  </p>
                ))}
              </section>
            )}
          </section>
          <section
            className="desc_subject_wrapper"
            // ref={languageRef}
            onClick={() => setOpenDropdown("questionCount")}
          >
            <h4>Number of Questions</h4>
            <section className="desc_drop_down_wrapper">
              <p>{selectedQuestionCount || "Select Number"}</p>
              <img src={assets.ic_chevron_down} alt="" />
            </section>
            {openDropdown === "questionCount" && (
              <section className="desc_options_list">
                {!selectedWeightage ? (
                  <p className="dropdown-message">
                    Please select weightage first
                  </p>
                ) : (
                  getQuestionCountOptions().map((item, i) => (
                    <p
                      key={i}
                      className="desc_option_item"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedQuestionCount(item);
                        setOpenDropdown(null);
                      }}
                    >
                      {item}
                    </p>
                  ))
                )}
              </section>
            )}
          </section>
          <button
            className="desc_start_quiz_wrapper"
            disabled={!isStartEnabled}
            onClick={async () => {
              await onStartQuiz();
              setIsQuizActive(true);
            }}
          >
            {/* Generate Questions*/}
            <img src={assets.ic_quest} alt="quest generate" />
            Generate Questions
          </button>
        </section>
      </section>
      <section
        className={`desc_wrapper ${isQuizActive ? "quiz_active" : "hero_active"}`}
      >
        {isQuizActive ? (
          <QuestionSection
            questionCount={selectedQuestionCount}
            questions={questions}
            onReset={handleResetAll}
            language={selectedLanguage || selectedMedium}
            mail={mail}
            section={section}
          />
        ) : (
          <DescriptiveHero />
        )}
      </section>
    </section>
  );
};
